import {
  updateResourceState,
  createResourceReducer,
  normalizeResourceState,
  RESOURCE
} from '@unicus/react-ui-kit';
import {
  INVOICE,
  INVOICE_SET_DEFAULT_INVOICE_SETTINGS,
  INVOICE_SET_DEFAULT_INVOICE_SETTINGS_FINISHED
} from './invoiceActions';

const invoiceReducer = createResourceReducer(INVOICE, [], {
  [INVOICE_SET_DEFAULT_INVOICE_SETTINGS](state, action) {
    return updateResourceState(state, action, RESOURCE, () => ({
      loading: true
    }));
  },

  [INVOICE_SET_DEFAULT_INVOICE_SETTINGS_FINISHED](state, action) {
    return updateResourceState(state, action, RESOURCE, () => ({
      loading: false,
      loaded: false
    }));
  }
});

export default invoiceReducer;
